export const workerViewApprovedQuery = [
  'id',
  'localizador',
  'funcionario__pagamento',
  'funcionario__nome',
  'funcionario__sobrenome',
  'financeira',
  'pagamento__agencia',
  'pagamento__agencia_dac',
  'pagamento__banco',
  'pagamento__banco_nome',
  'pagamento__conta',
  'pagamento__conta_dac',
  'pagamento__chave_pix',
  'pagamento__tipo_chave_pix',
  'pagamento__tipo',
  'data_primeiro_vencimento',
  'data_ultimo_vencimento',
  'ultimo_vencimento',
  'prazo',
  'valor_recebivel',
  'status_averbacao',
  'valor_financiado',
  'valor_solicitado',
  'valor_seguro',
  'data_solicitacao',
  'valor_iof',
  'valor_seguro',
  'status',
  'taxa_iof',
  'taxa_contrato',
  'taxa_iof_complementar',
  'taxa_cet_mes',
  'taxa_cet_ano',
  'cet_anual',
  'taxa_contrato_ano',
  'valor_tarifas',
  'taxa_multa',
  'valor_total_devido',
  'valor_liberado',
  'origem',
  'taxa_permanencia',
  'parcelas_info',
  'saldo_devedor',
  'alienacao',
  'entrada',
  'ccb_original_pdf',
  'ccb_original_html',
  'protocolo_digital_pdf',
  'valor_a_liquidar',
  'migrado_em',
  'convenio',
  'seguradora__tipo_seguro',
]

export const workerViewQuery = [
  'id',
  'nome',
  'bloqueado',
  'sobrenome',
  'data_nascimento',
  'sexo',
  'dependentes',
  'cpf',
  'nome_mae',
  'estado_civil',
  'margem_disponivel',
  'margem_rescisao',
  'matricula',
  'data_admissao',
  'email',
  'email_secundario',
  'descontos',
  'status',
  'limites',
  'demissao',
  'cadastro_ativo',
  'documento__tipo',
  'documento__numero',
  'documento__emissor',
  'documento__uf',
  'cargo',
  'data_admissao',
  'salario',
  'inss',
  'irrf',
  'valor_emprestado',
  'comprometimento_outros',
  'nacionalidade',
  'matricula',
  'proximo_corte',
  'saldo_devedor',
  'saldo_devedor_no_proximo_vencimento',
  'empresa__dia_corte',
  'dados_bancarios__banco',
  'dados_bancarios__agencia',
  'dados_bancarios__agencia_dac',
  'dados_bancarios__conta',
  'dados_bancarios__conta_dac',
  'dados_bancarios__tipo',
  'dados_bancarios__tipo_chave_pix',
  'dados_bancarios__chave_pix',
  'endereco__cep',
  'endereco__cidade',
  'endereco__uf',
  'endereco__bairro',
  'endereco__numero',
  'endereco__complemento',
  'endereco__logradouro',
  'endereco__pais',
  'referencia_nome',
  'referencia_telefone',
  'referencia_parentesco',
  'telefone_celular',
  'possui_acesso',
  'ultimo_login',
  'cnpj_empregador',
  'nome_empregador',
  'empresa',
]

// TODO: unificar com workerViewQuery
export const workerCompanyViewQuery = [
  'id',
  'nome',
  'bloqueado',
  'sobrenome',
  'data_nascimento',
  'estado_civil',
  'sexo',
  'dependentes',
  'cpf',
  'matricula',
  'data_admissao',
  'email',
  'status',
  'cadastro_ativo',
  'cargo',
  'data_admissao',
  'salario_bruto',
  'matricula',
  'documento__tipo',
  'documento__numero',
  'documento__emissor',
  'documento__uf',
  'dados_bancarios__banco',
  'dados_bancarios__agencia',
  'dados_bancarios__agencia_dac',
  'dados_bancarios__conta',
  'dados_bancarios__conta_dac',
  'dados_bancarios__tipo',
  'dados_bancarios__tipo_chave_pix',
  'dados_bancarios__chave_pix',
  'endereco__cep',
  'endereco__cidade',
  'endereco__uf',
  'endereco__bairro',
  'endereco__numero',
  'endereco__complemento',
  'endereco__logradouro',
  'endereco__pais',
  'referencia_nome',
  'referencia_telefone',
  'referencia_parentesco',
  'telefone_celular',
  'possui_acesso',
  'ultimo_login',
]

export const workersCardQuery = [
  'id',
  'nome',
  'sobrenome',
  'status',
  'matricula',
  'possui_acesso',
  'ultimo_login',
  'cpf',
  'cadastro_ativo',
]
